module.exports = __webpack_public_path__ + "static/media/portfolio.03d2bda3.png";